import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.accounts')
  .factory('accountsAPI', AccountsAPI);

function AccountsAPI(): BringozApi {
  return {
    base: `/accounts`,
    infiniteScroll: {
      address: `/accounts`,
      cmd: 'GET'
    },
    actions: {
      getPreferences: {
        address: 'preferences',
        updateable: false,
        cmd: 'GET'
      },
      updatePreferences: {
        address: 'preferences',
        updateable: false,
        cmd: 'POST'
      },
      getAccountPricePlanBundleUser: {
        address: 'priceplan',
        updateable: false,
        cmd: 'GET'
      },
      getAll: {
        address: 'all',
        cmd: 'GET'
      },
      getTotalAccounts: {
        address: 'totals/statuses',
        updateable: false,
        cmd: 'GET'
      },
      setAccountPricePlanBundle: {
        address: 'priceplan/{bundleId}',
        updateable: false,
        cmd: 'POST'
      },
      addUserToAccount: {
        address: 'roles',
        updateable: false,
        cmd: 'POST'
      },
      createOne: {
        address: '',
        updateable: true,
        cmd: 'PUT'
      },
      updateOne: {
        address: '',
        updateable: true,
        cmd: 'POST'
      },
      deleteAccount: {
        address: '',
        updateable: false,
        cmd: 'DELETE'
      },
      addDepotToAccounts: {
        address: 'depot',
        updateable: true,
        cmd: 'POST'
      },
      exportAccounts: {
        address: 'actions/export',
        updateable: false,
        cmd: 'POST'
      },
      updateAccountProfile: {
        address: 'configProfile',
        updateable: true,
        cmd: 'POST'
      },
      removeContract: {
        address: '{accountId}/removeContract',
        updateable: true,
        cmd: 'POST'
      },
      unArchive: {
        address: 'unArchive',
        updateable: true,
        cmd: 'POST'
      },
      addBranches: {
        address: 'addBranches',
        updateable: true,
        cmd: 'POST'
      },
      setSchedulingProjectConfigurations: {
        address: 'strategic/{id}',
        cmd: 'POST'
      },
      getPreferredAgents: {
        address: '{accountId}/preferences/agents',
        updateable: false,
        cmd: 'GET'
      },
      createPreferredAgent: {
        address: '{accountId}/preferences/agents',
        updateable: true,
        cmd: 'PUT'
      },
      deletePreferredAgents: {
        address: '{accountId}/preferences/agents',
        updateable: false,
        cmd: 'DELETE'
      },
      updatePreferredAgents: {
        address: '{accountId}/preferences/agents',
        updateable: true,
        cmd: 'POST'
      },
      getRestrictedAgents: {
        address: '{accountId}/preferences/agents/restricted',
        updateable: false,
        cmd: 'GET'
      },
      createRestrictedAgent: {
        address: '{accountId}/preferences/agents/restricted',
        updateable: true,
        cmd: 'PUT'
      },
      updateRestrictedAgents: {
        address: '{accountId}/preferences/agents',
        updateable: true,
        cmd: 'POST'
      },
      deleteRestrictedAgents: {
        address: '{accountId}/preferences/agents',
        updateable: false,
        cmd: 'DELETE'
      },
      getDedicatedAgents: {
        address: '{accountId}/preferences/agents/dedicated',
        updateable: false,
        cmd: 'GET'
      },
      createDedicatedAgent: {
        address: '{accountId}/preferences/agents/dedicated',
        updateable: true,
        cmd: 'PUT'
      },
      updateDedicatedAgents: {
        address: '{accountId}/preferences/agents/dedicated',
        updateable: true,
        cmd: 'POST'
      },
      deleteDedicatedAgents: {
        address: '{accountId}/preferences/agents/dedicated',
        updateable: false,
        cmd: 'DELETE'
      },
      getAccountsWithPreferredAgents: {
        address: 'preferredAgents',
        updateable: false,
        cmd: 'GET'
      },
      getAccountsWithPreferredAgentsCursor: {
        address: 'preferredAgents/cursor',
        updateable: false,
        cmd: 'GET'
      },
      assignMultiplePreferredAgents: {
        address: '{accountId}/preferences/agents/assignMultiple',
        updateable: true,
        cmd: 'POST'
      },
      updateMetaData: {
        address: '{accountId}/metadata',
        updateable: false,
        cmd: 'PUT'
      },
    }
  }
}
